import { useSelector } from "react-redux";
import { Box, Divider, Drawer, Stack } from "@mui/material";
import { Link } from "react-router-dom";

import { ButtonCloseSesion } from "./components/ButtonCloseSesion";
import { MenuListDrawer } from "./components/MenuListDrawer";

export const DrawerLayout = () => {
  const { drawerIsOpen } = useSelector((state) => state.layout);

  return (
    <>
      <Drawer
        anchor="left"
        open={drawerIsOpen}
        variant="persistent"
        sx={{ width: 240 }}
      >
        <Box
          sx={{
            width: 240,
            height: "100vh",
            backgroundColor: "#001B60",
            position: "fixed",
          }}
        >
          {drawerIsOpen ? (
            <Box textAlign="center" sx={{ height: "64px", paddingTop: "8px" }}>
              <Link to="/">
                <img src="/logo-navbar.png" alt="Logo Faraday" />
              </Link>
            </Box>
          ) : (
            <Box textAlign="center" sx={{ height: "64px", paddingTop: "8px" }}>
              <img
                style={{ height: "25px" }}
                src="/logo-navbar.png"
                alt="Logo Faraday"
              />
            </Box>
          )}

          <Divider color="white" />
          <Stack height="calc(100% - 70px)" justifyContent="space-between">
            <MenuListDrawer size="big" />
            <ButtonCloseSesion size="big" />
          </Stack>
        </Box>
      </Drawer>
      <Drawer
        anchor="left"
        open={!drawerIsOpen}
        variant="persistent"
        sx={{ width: 60 }}
      >
        <Box
          sx={{
            width: 60,
            height: "100vh",
            backgroundColor: "#001B60",
            position: "fixed",
          }}
        >
          <Box textAlign="center" sx={{ height: "64px", paddingTop: "7px" }}>
            <img
              style={{ width: "135px", marginLeft: "9px" }}
              src="/logo-navbar.png"
              alt="Logo Faraday"
            />
          </Box>
          <Divider color="white" />
          <Stack height="calc(100% - 70px)" justifyContent="space-between">
            <MenuListDrawer size="small" />
            <ButtonCloseSesion size="small" />
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};
